var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelpToolTip',{attrs:{"size":16,"close-delay":600},scopedSlots:_vm._u([{key:"message",fn:function(){return [_c('p',[_vm._v(" "+_vm._s(_vm.$t('scuHoursTip'))+" ")]),_c('a',{attrs:{"href":_vm.docLink,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('learn-more'))+" ")])]},proxy:true}])})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }